import { forwardRef } from "react";
import { NavLink, Link as RouterLink } from "react-router-dom";

import isAbsolutePath from "@/utils/is-absolute-path";

export const Link = forwardRef(function Link({ isNav, ...props }, ref) {
  if (isAbsolutePath(props.href)) {
    return <a {...props} ref={ref} target={props.target ?? "_blank"} />;
  }

  if (isNav) {
    return <NavLink {...props} to={props.href} ref={ref} />;
  }

  return <RouterLink {...props} to={props.href} ref={ref} />;
});

export default Link;
